import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://soy.esenttia.co/api-bridge.php',  // Ajusta esto a la URL de tu backend
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;